(() => {
  const root = window.Shopify?.routes?.root || '/';

  async function request(path, options = {}) {
    const response = await fetch(root + path, { ...options, headers: { Accept: 'application/json', ...options.headers } });
    const data = await response.json();
    if (!response.ok) throw data;
    return data;
  }

  function loadConfig() {
    const el = document.getElementById('mp-halloween-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function numericId(gid) {
    if (!gid) return null;
    const n = Number(String(gid).split('/').pop());
    return Number.isFinite(n) && n > 0 ? n : null;
  }

  let syncing = false;
  let pendingResync = false;

  async function refreshCartUI() {
    const cart = await request('cart.js');
    document.querySelectorAll('[data-cart-count]').forEach(n => (n.textContent = String(cart.item_count)));
    try {
      const response = await fetch(root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } });
      if (response.ok) {
        const sections = await response.json();
        const doc = new DOMParser().parseFromString(sections['cart-drawer'] || '', 'text/html');
        const content = doc.querySelector('#DrawerContent');
        const current = document.getElementById('DrawerContent');
        if (content && current) current.innerHTML = content.innerHTML;
      }
    } catch (e) {
      // Cart drawer markup refresh is best-effort; item counts above already updated.
    }
    return cart;
  }

  async function syncGift(cartHint) {
    const config = loadConfig();
    if (!config || !config.active || !config.giftEnabled) return;
    const frameProductId = numericId(config.frameProductId);
    const giftVariantId = numericId(config.giftVariantId);
    if (!frameProductId || !giftVariantId || !config.giftVariantAvailable) return;

    if (syncing) {
      pendingResync = true;
      return;
    }
    syncing = true;
    try {
      const cart = cartHint || (await request('cart.js'));
      const frameQty = cart.items
        .filter(item => Number(item.product_id) === frameProductId)
        .reduce((sum, item) => sum + item.quantity, 0);
      const giftLine = cart.items.find(item => item.properties && item.properties._mp_free_gift === 'true');
      const eligible = frameQty >= (config.giftThreshold || 3);

      if (eligible && !giftLine) {
        await request('cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: giftVariantId, quantity: 1, properties: { _mp_free_gift: 'true' } }] }),
        });
        await refreshCartUI();
      } else if (!eligible && giftLine) {
        await request('cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: giftLine.key, quantity: 0 }),
        });
        await refreshCartUI();
      }
    } catch (e) {
      // Non-fatal: once the matching Shopify discount is configured it still
      // enforces the free price at checkout even if this sync step fails.
    } finally {
      syncing = false;
      if (pendingResync) {
        pendingResync = false;
        syncGift();
      }
    }
  }

  window.MPHalloween = { syncGift };

  document.addEventListener('mp:cart:updated', event => syncGift(event.detail && event.detail.cart));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncGift());
  } else {
    syncGift();
  }
})();
